export const content = {
  header: [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Collection",
      link: "/collection",
    },
    {
      title: "About",
      link: "/about-us",
    },
  ],
  Footer: [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Collection",
      link: "/collection",
    },
    {
      title: "About",
      link: "/about-us",
    },
    {
      title: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      title: "Terms & Conditions",
      link: "/terms-and-conditions",
    },
  ],
  profileFooter: [
    {
      title: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      title: "Terms & Conditions",
      link: "/terms-and-conditions",
    },
    {
      title: "Disclaimer",
      link: "/disclaimer",
    },
  ],
  HomeCarouselSlider:[
    {
      icon: "/assets/home-slider-image-1.png",
    },
    {
      icon: "/assets/home-slider-image-2.png",
    },
    {
      icon: "/assets/home-slider-image-3.png",
    },
    {
      icon: "/assets/home-slider-image-4.png",
    }
  ],
  socialIcons: [
    {
      link: "https://discord.com/",
      icon: ( <svg
          width="48"
          height="36"
          viewBox="0 0 48 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.9375 3.46875C45.0938 11.125 47.6719 19.7188 46.7344 29.6406C46.7344 29.6406 46.7344 29.7188 46.6562 29.7188C43.2188 32.2969 39.3125 34.25 35.1719 35.5C35.0938 35.5781 35.0938 35.5 35.0156 35.5C34.1562 34.25 33.375 33 32.6719 31.6719C32.6719 31.5938 32.6719 31.5156 32.75 31.4375C34 30.9688 35.1719 30.4219 36.3438 29.7188C36.4219 29.7188 36.4219 29.5625 36.3438 29.4844C36.1094 29.3281 35.875 29.1719 35.6406 28.9375C35.5625 28.9375 35.5625 28.9375 35.4844 28.9375C28.0625 32.375 19.9375 32.375 12.4375 28.9375C12.3594 28.9375 12.2812 28.9375 12.2812 28.9375C12.0469 29.1719 11.8125 29.3281 11.5781 29.4844C11.4219 29.5625 11.5 29.7188 11.5781 29.7188C12.6719 30.4219 13.9219 30.9688 15.1719 31.4375C15.25 31.5156 15.25 31.5938 15.25 31.6719C14.5469 33 13.7656 34.25 12.9062 35.5C12.8281 35.5 12.75 35.5781 12.75 35.5C8.60938 34.25 4.70312 32.2969 1.26562 29.7188C1.1875 29.7188 1.1875 29.6406 1.1875 29.6406C0.40625 21.0469 2.04688 12.375 7.98438 3.46875C7.98438 3.46875 7.98438 3.46875 8.0625 3.46875C11.0312 2.0625 14.1562 1.125 17.3594 0.578125C17.4375 0.5 17.5156 0.578125 17.5156 0.578125C17.9844 1.35938 18.375 2.21875 18.6875 3C22.2031 2.45312 25.7188 2.45312 29.2344 3C29.5469 2.21875 29.9375 1.35938 30.4062 0.578125C30.4062 0.578125 30.4844 0.5 30.5625 0.578125C33.7656 1.125 36.8906 2.0625 39.8594 3.46875C39.9375 3.46875 39.9375 3.46875 39.9375 3.46875ZM16.3438 24.4062C18.6094 24.4062 20.4844 22.2969 20.4844 19.7969C20.4844 17.2188 18.6875 15.1875 16.3438 15.1875C14.0781 15.1875 12.2031 17.2188 12.2031 19.7969C12.2031 22.2969 14.0781 24.4062 16.3438 24.4062ZM31.5781 24.4062C33.9219 24.4062 35.7188 22.2969 35.7188 19.7969C35.7969 17.2188 33.9219 15.1875 31.5781 15.1875C29.3125 15.1875 27.5156 17.2188 27.5156 19.7969C27.5156 22.2969 29.3125 24.4062 31.5781 24.4062Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      link: "https://www.instagram.com/",
      icon: ( <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http:www.w3.org/2000/svg"
        >
          <path
            d="M18.5 9.01562C23.4219 9.01562 27.4844 13.0781 27.4844 18C27.4844 23 23.4219 26.9844 18.5 26.9844C13.5 26.9844 9.51562 23 9.51562 18C9.51562 13.0781 13.5 9.01562 18.5 9.01562ZM18.5 23.8594C21.7031 23.8594 24.2812 21.2812 24.2812 18C24.2812 14.7969 21.7031 12.2188 18.5 12.2188C15.2188 12.2188 12.6406 14.7969 12.6406 18C12.6406 21.2812 15.2969 23.8594 18.5 23.8594ZM29.9062 8.70312C29.9062 7.53125 28.9688 6.59375 27.7969 6.59375C26.625 6.59375 25.6875 7.53125 25.6875 8.70312C25.6875 9.875 26.625 10.8125 27.7969 10.8125C28.9688 10.8125 29.9062 9.875 29.9062 8.70312ZM35.8438 10.8125C36 13.7031 36 22.375 35.8438 25.2656C35.6875 28.0781 35.0625 30.5 33.0312 32.6094C31 34.6406 28.5 35.2656 25.6875 35.4219C22.7969 35.5781 14.125 35.5781 11.2344 35.4219C8.42188 35.2656 6 34.6406 3.89062 32.6094C1.85938 30.5 1.23438 28.0781 1.07812 25.2656C0.921875 22.375 0.921875 13.7031 1.07812 10.8125C1.23438 8 1.85938 5.5 3.89062 3.46875C6 1.4375 8.42188 0.8125 11.2344 0.65625C14.125 0.5 22.7969 0.5 25.6875 0.65625C28.5 0.8125 31 1.4375 33.0312 3.46875C35.0625 5.5 35.6875 8 35.8438 10.8125ZM32.0938 28.3125C33.0312 26.0469 32.7969 20.5781 32.7969 18C32.7969 15.5 33.0312 10.0312 32.0938 7.6875C31.4688 6.20312 30.2969 4.95312 28.8125 4.40625C26.4688 3.46875 21 3.70312 18.5 3.70312C15.9219 3.70312 10.4531 3.46875 8.1875 4.40625C6.625 5.03125 5.45312 6.20312 4.82812 7.6875C3.89062 10.0312 4.125 15.5 4.125 18C4.125 20.5781 3.89062 26.0469 4.82812 28.3125C5.45312 29.875 6.625 31.0469 8.1875 31.6719C10.4531 32.6094 15.9219 32.375 18.5 32.375C21 32.375 26.4688 32.6094 28.8125 31.6719C30.2969 31.0469 31.5469 29.875 32.0938 28.3125Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      link: "https://twitter.com/",
      icon: ( <svg
          width="34"
          height="30"
          viewBox="0 0 34 30"
          fill="none"
          xmlns="http:www.w3.org/2000/svg"
        >
          <path
            d="M26.777 0H31.9905L20.6005 12.7077L34 30H23.5083L15.2908 19.5123L5.88806 30H0.671396L12.8542 16.4077L0 0H10.758L18.1859 9.58615L26.777 0ZM24.9472 26.9538H27.8361L9.1883 2.88615H6.08822L24.9472 26.9538Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      link: "https://www.facebook.com/",
      icon: ( <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http:www.w3.org/2000/svg"
        >
          <path
            d="M39.375 20C39.375 29.6875 32.2656 37.7344 22.9688 39.1406V25.625H27.5L28.3594 20H22.9688V16.4062C22.9688 14.8438 23.75 13.3594 26.1719 13.3594H28.5938V8.59375C28.5938 8.59375 26.4062 8.20312 24.2188 8.20312C19.8438 8.20312 16.9531 10.9375 16.9531 15.7812V20H12.0312V25.625H16.9531V39.1406C7.65625 37.7344 0.625 29.6875 0.625 20C0.625 9.29688 9.29688 0.625 20 0.625C30.7031 0.625 39.375 9.29688 39.375 20Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
  ],
  socialIconImages: [
    {
      link: "https://discord.com/",
      icon: "/assets/discord-f.png",
    },
    {
      link: "https://www.instagram.com/",
      icon: "/assets/instagram-f.png",
    },
    {
      link: "https://twitter.com/",
      icon: "/assets/twitter-f.png",
    },
    {
      link: "https://www.facebook.com/",
      icon: "/assets/facebook-f.png",
    },
  ],
  nftCarousel: [
    {
      imgUrl: "/assets/hero-nft-1.png",
    },
    {
      imgUrl: "/assets/hero-nft-2.png",
    },
    {
      imgUrl: "/assets/hero-nft-3.png",
    },
    {
      imgUrl: "/assets/hero-nft-2.png",
    },
    {
      imgUrl: "/assets/hero-nft-1.png",
    },
  ],
  CuratedNFTs: [
    {
      imgUrl: "/assets/curated-nft-1.png",
      imgUrl2: "/assets/curated-nft-2.png",
    },
    {
      imgUrl: "/assets/curated-nft-3.png",
      imgUrl2: "/assets/curated-nft-4.png",
    },
    {
      imgUrl: "/assets/curated-nft-5.png",
      imgUrl2: "/assets/curated-nft-6.png",
    },
    {
      imgUrl: "/assets/curated-nft-7.png",
      imgUrl2: "/assets/curated-nft-8.png",
    },
    {
      imgUrl: "/assets/curated-nft-9.png",
      imgUrl2: "/assets/curated-nft-10.png",
    },
    {
      imgUrl: "/assets/curated-nft-1.png",
      imgUrl2: "/assets/curated-nft-2.png",
    },
    {
      imgUrl: "/assets/curated-nft-3.png",
      imgUrl2: "/assets/curated-nft-4.png",
    },
    {
      imgUrl: "/assets/curated-nft-5.png",
      imgUrl2: "/assets/curated-nft-6.png",
    },
    {
      imgUrl: "/assets/curated-nft-7.png",
      imgUrl2: "/assets/curated-nft-8.png",
    },
    {
      imgUrl: "/assets/curated-nft-9.png",
      imgUrl2: "/assets/curated-nft-10.png",
    },
  ],
  MarqueNFTs: [
    {
      imgUrl: "/assets/our-mission-1.png",
    },
    {
      imgUrl: "/assets/our-mission-2.png",
    },
    {
      imgUrl: "/assets/our-mission-3.png",
    },
    {
      imgUrl: "/assets/our-mission-4.png",
    },
    {
      imgUrl: "/assets/our-mission-5.png",
    },
    {
      imgUrl: "/assets/marque-nft-6.png",
    },
    {
      imgUrl: "/assets/our-mission-2.png",
    },
    {
      imgUrl: "/assets/our-mission-3.png",
    },
    {
      imgUrl: "/assets/our-mission-4.png",
    },
    {
      imgUrl: "/assets/our-mission-5.png",
    },

   
  ],
  tiersLevels: [
    { Title: "Tier 1" },
    { Title: "Tier 2" },
    { Title: "Tier 3" },
    { Title: "Tier 4" },
    { Title: "Tier 5" },
    { Title: "Metaverse" },
  ],
  minted: [{ title: "All" }, { title: "Minted" }, { title: "Not Minted" }],

  Artist: [
    {
      imgUrl: "/assets/artist.svg",
      Name: "John Deo",
      Profession: "Graphic designer",
      socialIcon: [
        {
          link: "https://www.instagram.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 27"
              fill="currentColor"
            >
              <path
                d="M14.125 6.79297C17.8164 6.79297 20.8633 9.83984 20.8633 13.5312C20.8633 17.2812 17.8164 20.2695 14.125 20.2695C10.375 20.2695 7.38672 17.2812 7.38672 13.5312C7.38672 9.83984 10.375 6.79297 14.125 6.79297ZM14.125 17.9258C16.5273 17.9258 18.4609 15.9922 18.4609 13.5312C18.4609 11.1289 16.5273 9.19531 14.125 9.19531C11.6641 9.19531 9.73047 11.1289 9.73047 13.5312C9.73047 15.9922 11.7227 17.9258 14.125 17.9258ZM22.6797 6.55859C22.6797 5.67969 21.9766 4.97656 21.0977 4.97656C20.2188 4.97656 19.5156 5.67969 19.5156 6.55859C19.5156 7.4375 20.2188 8.14062 21.0977 8.14062C21.9766 8.14062 22.6797 7.4375 22.6797 6.55859ZM27.1328 8.14062C27.25 10.3086 27.25 16.8125 27.1328 18.9805C27.0156 21.0898 26.5469 22.9062 25.0234 24.4883C23.5 26.0117 21.625 26.4805 19.5156 26.5977C17.3477 26.7148 10.8438 26.7148 8.67578 26.5977C6.56641 26.4805 4.75 26.0117 3.16797 24.4883C1.64453 22.9062 1.17578 21.0898 1.05859 18.9805C0.941406 16.8125 0.941406 10.3086 1.05859 8.14062C1.17578 6.03125 1.64453 4.15625 3.16797 2.63281C4.75 1.10938 6.56641 0.640625 8.67578 0.523438C10.8438 0.40625 17.3477 0.40625 19.5156 0.523438C21.625 0.640625 23.5 1.10938 25.0234 2.63281C26.5469 4.15625 27.0156 6.03125 27.1328 8.14062ZM24.3203 21.2656C25.0234 19.5664 24.8477 15.4648 24.8477 13.5312C24.8477 11.6562 25.0234 7.55469 24.3203 5.79688C23.8516 4.68359 22.9727 3.74609 21.8594 3.33594C20.1016 2.63281 16 2.80859 14.125 2.80859C12.1914 2.80859 8.08984 2.63281 6.39062 3.33594C5.21875 3.80469 4.33984 4.68359 3.87109 5.79688C3.16797 7.55469 3.34375 11.6562 3.34375 13.5312C3.34375 15.4648 3.16797 19.5664 3.87109 21.2656C4.33984 22.4375 5.21875 23.3164 6.39062 23.7852C8.08984 24.4883 12.1914 24.3125 14.125 24.3125C16 24.3125 20.1016 24.4883 21.8594 23.7852C22.9727 23.3164 23.9102 22.4375 24.3203 21.2656Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
        {
          link: "https://www.facebook.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 29"
              fill="currentColor"
            >
              <path
                d="M29.5312 14.5312C29.5312 21.7969 24.1992 27.832 17.2266 28.8867V18.75H20.625L21.2695 14.5312H17.2266V11.8359C17.2266 10.6641 17.8125 9.55078 19.6289 9.55078H21.4453V5.97656C21.4453 5.97656 19.8047 5.68359 18.1641 5.68359C14.8828 5.68359 12.7148 7.73438 12.7148 11.3672V14.5312H9.02344V18.75H12.7148V28.8867C5.74219 27.832 0.46875 21.7969 0.46875 14.5312C0.46875 6.50391 6.97266 0 15 0C23.0273 0 29.5312 6.50391 29.5312 14.5312Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
      ],
    },
    {
      imgUrl: "/assets/artist.svg",
      Name: "John Deo",
      Profession: "Graphic designer",
      socialIcon: [
        {
          link: "https://www.instagram.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 27"
              fill="currentColor"
            >
              <path
                d="M14.125 6.79297C17.8164 6.79297 20.8633 9.83984 20.8633 13.5312C20.8633 17.2812 17.8164 20.2695 14.125 20.2695C10.375 20.2695 7.38672 17.2812 7.38672 13.5312C7.38672 9.83984 10.375 6.79297 14.125 6.79297ZM14.125 17.9258C16.5273 17.9258 18.4609 15.9922 18.4609 13.5312C18.4609 11.1289 16.5273 9.19531 14.125 9.19531C11.6641 9.19531 9.73047 11.1289 9.73047 13.5312C9.73047 15.9922 11.7227 17.9258 14.125 17.9258ZM22.6797 6.55859C22.6797 5.67969 21.9766 4.97656 21.0977 4.97656C20.2188 4.97656 19.5156 5.67969 19.5156 6.55859C19.5156 7.4375 20.2188 8.14062 21.0977 8.14062C21.9766 8.14062 22.6797 7.4375 22.6797 6.55859ZM27.1328 8.14062C27.25 10.3086 27.25 16.8125 27.1328 18.9805C27.0156 21.0898 26.5469 22.9062 25.0234 24.4883C23.5 26.0117 21.625 26.4805 19.5156 26.5977C17.3477 26.7148 10.8438 26.7148 8.67578 26.5977C6.56641 26.4805 4.75 26.0117 3.16797 24.4883C1.64453 22.9062 1.17578 21.0898 1.05859 18.9805C0.941406 16.8125 0.941406 10.3086 1.05859 8.14062C1.17578 6.03125 1.64453 4.15625 3.16797 2.63281C4.75 1.10938 6.56641 0.640625 8.67578 0.523438C10.8438 0.40625 17.3477 0.40625 19.5156 0.523438C21.625 0.640625 23.5 1.10938 25.0234 2.63281C26.5469 4.15625 27.0156 6.03125 27.1328 8.14062ZM24.3203 21.2656C25.0234 19.5664 24.8477 15.4648 24.8477 13.5312C24.8477 11.6562 25.0234 7.55469 24.3203 5.79688C23.8516 4.68359 22.9727 3.74609 21.8594 3.33594C20.1016 2.63281 16 2.80859 14.125 2.80859C12.1914 2.80859 8.08984 2.63281 6.39062 3.33594C5.21875 3.80469 4.33984 4.68359 3.87109 5.79688C3.16797 7.55469 3.34375 11.6562 3.34375 13.5312C3.34375 15.4648 3.16797 19.5664 3.87109 21.2656C4.33984 22.4375 5.21875 23.3164 6.39062 23.7852C8.08984 24.4883 12.1914 24.3125 14.125 24.3125C16 24.3125 20.1016 24.4883 21.8594 23.7852C22.9727 23.3164 23.9102 22.4375 24.3203 21.2656Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
        {
          link: "https://www.facebook.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 29"
              fill="currentColor"
            >
              <path
                d="M29.5312 14.5312C29.5312 21.7969 24.1992 27.832 17.2266 28.8867V18.75H20.625L21.2695 14.5312H17.2266V11.8359C17.2266 10.6641 17.8125 9.55078 19.6289 9.55078H21.4453V5.97656C21.4453 5.97656 19.8047 5.68359 18.1641 5.68359C14.8828 5.68359 12.7148 7.73438 12.7148 11.3672V14.5312H9.02344V18.75H12.7148V28.8867C5.74219 27.832 0.46875 21.7969 0.46875 14.5312C0.46875 6.50391 6.97266 0 15 0C23.0273 0 29.5312 6.50391 29.5312 14.5312Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
      ],
    },
    {
      imgUrl: "/assets/artist.svg",
      Name: "John Deo",
      Profession: "Graphic designer",
      socialIcon: [
        {
          link: "https://www.instagram.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 27"
              fill="currentColor"
            >
              <path
                d="M14.125 6.79297C17.8164 6.79297 20.8633 9.83984 20.8633 13.5312C20.8633 17.2812 17.8164 20.2695 14.125 20.2695C10.375 20.2695 7.38672 17.2812 7.38672 13.5312C7.38672 9.83984 10.375 6.79297 14.125 6.79297ZM14.125 17.9258C16.5273 17.9258 18.4609 15.9922 18.4609 13.5312C18.4609 11.1289 16.5273 9.19531 14.125 9.19531C11.6641 9.19531 9.73047 11.1289 9.73047 13.5312C9.73047 15.9922 11.7227 17.9258 14.125 17.9258ZM22.6797 6.55859C22.6797 5.67969 21.9766 4.97656 21.0977 4.97656C20.2188 4.97656 19.5156 5.67969 19.5156 6.55859C19.5156 7.4375 20.2188 8.14062 21.0977 8.14062C21.9766 8.14062 22.6797 7.4375 22.6797 6.55859ZM27.1328 8.14062C27.25 10.3086 27.25 16.8125 27.1328 18.9805C27.0156 21.0898 26.5469 22.9062 25.0234 24.4883C23.5 26.0117 21.625 26.4805 19.5156 26.5977C17.3477 26.7148 10.8438 26.7148 8.67578 26.5977C6.56641 26.4805 4.75 26.0117 3.16797 24.4883C1.64453 22.9062 1.17578 21.0898 1.05859 18.9805C0.941406 16.8125 0.941406 10.3086 1.05859 8.14062C1.17578 6.03125 1.64453 4.15625 3.16797 2.63281C4.75 1.10938 6.56641 0.640625 8.67578 0.523438C10.8438 0.40625 17.3477 0.40625 19.5156 0.523438C21.625 0.640625 23.5 1.10938 25.0234 2.63281C26.5469 4.15625 27.0156 6.03125 27.1328 8.14062ZM24.3203 21.2656C25.0234 19.5664 24.8477 15.4648 24.8477 13.5312C24.8477 11.6562 25.0234 7.55469 24.3203 5.79688C23.8516 4.68359 22.9727 3.74609 21.8594 3.33594C20.1016 2.63281 16 2.80859 14.125 2.80859C12.1914 2.80859 8.08984 2.63281 6.39062 3.33594C5.21875 3.80469 4.33984 4.68359 3.87109 5.79688C3.16797 7.55469 3.34375 11.6562 3.34375 13.5312C3.34375 15.4648 3.16797 19.5664 3.87109 21.2656C4.33984 22.4375 5.21875 23.3164 6.39062 23.7852C8.08984 24.4883 12.1914 24.3125 14.125 24.3125C16 24.3125 20.1016 24.4883 21.8594 23.7852C22.9727 23.3164 23.9102 22.4375 24.3203 21.2656Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
        {
          link: "https://www.facebook.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 29"
              fill="currentColor"
            >
              <path
                d="M29.5312 14.5312C29.5312 21.7969 24.1992 27.832 17.2266 28.8867V18.75H20.625L21.2695 14.5312H17.2266V11.8359C17.2266 10.6641 17.8125 9.55078 19.6289 9.55078H21.4453V5.97656C21.4453 5.97656 19.8047 5.68359 18.1641 5.68359C14.8828 5.68359 12.7148 7.73438 12.7148 11.3672V14.5312H9.02344V18.75H12.7148V28.8867C5.74219 27.832 0.46875 21.7969 0.46875 14.5312C0.46875 6.50391 6.97266 0 15 0C23.0273 0 29.5312 6.50391 29.5312 14.5312Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
      ],
    },
    {
      imgUrl: "/assets/artist.svg",
      Name: "John Deo",
      Profession: "Graphic designer",
      socialIcon: [
        {
          link: "https://www.instagram.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 27"
              fill="currentColor"
            >
              <path
                d="M14.125 6.79297C17.8164 6.79297 20.8633 9.83984 20.8633 13.5312C20.8633 17.2812 17.8164 20.2695 14.125 20.2695C10.375 20.2695 7.38672 17.2812 7.38672 13.5312C7.38672 9.83984 10.375 6.79297 14.125 6.79297ZM14.125 17.9258C16.5273 17.9258 18.4609 15.9922 18.4609 13.5312C18.4609 11.1289 16.5273 9.19531 14.125 9.19531C11.6641 9.19531 9.73047 11.1289 9.73047 13.5312C9.73047 15.9922 11.7227 17.9258 14.125 17.9258ZM22.6797 6.55859C22.6797 5.67969 21.9766 4.97656 21.0977 4.97656C20.2188 4.97656 19.5156 5.67969 19.5156 6.55859C19.5156 7.4375 20.2188 8.14062 21.0977 8.14062C21.9766 8.14062 22.6797 7.4375 22.6797 6.55859ZM27.1328 8.14062C27.25 10.3086 27.25 16.8125 27.1328 18.9805C27.0156 21.0898 26.5469 22.9062 25.0234 24.4883C23.5 26.0117 21.625 26.4805 19.5156 26.5977C17.3477 26.7148 10.8438 26.7148 8.67578 26.5977C6.56641 26.4805 4.75 26.0117 3.16797 24.4883C1.64453 22.9062 1.17578 21.0898 1.05859 18.9805C0.941406 16.8125 0.941406 10.3086 1.05859 8.14062C1.17578 6.03125 1.64453 4.15625 3.16797 2.63281C4.75 1.10938 6.56641 0.640625 8.67578 0.523438C10.8438 0.40625 17.3477 0.40625 19.5156 0.523438C21.625 0.640625 23.5 1.10938 25.0234 2.63281C26.5469 4.15625 27.0156 6.03125 27.1328 8.14062ZM24.3203 21.2656C25.0234 19.5664 24.8477 15.4648 24.8477 13.5312C24.8477 11.6562 25.0234 7.55469 24.3203 5.79688C23.8516 4.68359 22.9727 3.74609 21.8594 3.33594C20.1016 2.63281 16 2.80859 14.125 2.80859C12.1914 2.80859 8.08984 2.63281 6.39062 3.33594C5.21875 3.80469 4.33984 4.68359 3.87109 5.79688C3.16797 7.55469 3.34375 11.6562 3.34375 13.5312C3.34375 15.4648 3.16797 19.5664 3.87109 21.2656C4.33984 22.4375 5.21875 23.3164 6.39062 23.7852C8.08984 24.4883 12.1914 24.3125 14.125 24.3125C16 24.3125 20.1016 24.4883 21.8594 23.7852C22.9727 23.3164 23.9102 22.4375 24.3203 21.2656Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
        {
          link: "https://www.facebook.com/",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 29"
              fill="currentColor"
            >
              <path
                d="M29.5312 14.5312C29.5312 21.7969 24.1992 27.832 17.2266 28.8867V18.75H20.625L21.2695 14.5312H17.2266V11.8359C17.2266 10.6641 17.8125 9.55078 19.6289 9.55078H21.4453V5.97656C21.4453 5.97656 19.8047 5.68359 18.1641 5.68359C14.8828 5.68359 12.7148 7.73438 12.7148 11.3672V14.5312H9.02344V18.75H12.7148V28.8867C5.74219 27.832 0.46875 21.7969 0.46875 14.5312C0.46875 6.50391 6.97266 0 15 0C23.0273 0 29.5312 6.50391 29.5312 14.5312Z"
                fill="currentColor"
              />
            </svg>
          ),
        },
      ],
    },
  ],
};
